import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { Button, Flex, Popconfirm, Space } from 'antd';
import type { FC } from 'react';
import { useCurrentUser } from '../../lib/customHooks';
import { useMonitorStore } from '../../store/monitor/monitorStore';
import { useStore } from '../../store/reducers';
import { AccountInfo } from '../BasicComponents/AccountInfo/AccountInfo';
import { EventTimes } from '../BasicComponents/EventTimes';
import { LoadingIndicator } from '../BasicComponents/LoadingIndicator';
import { LoginButton } from '../LoginButton';

export const Header: FC = () => {
  const event = useMonitorStore((s) => s.event);
  const isLoadingData = useMonitorStore((s) => s.isLoadingData);
  const isLoadingLiveData = useMonitorStore((s) => s.isLoadingLiveData);
  const loading = isLoadingData || isLoadingLiveData;

  const eventName = event?.name;
  const currentUser = useCurrentUser();
  const { logout } = useStore((s) => s.users.actions);

  if (event == null) return null;

  return (
    <Container justify="space-between" align="center">
      <Space direction="vertical">
        <Title>{eventName}</Title>
        <EventTimes event={event} />
      </Space>
      <Space size="large">
        <LoadingIndicator isLoading={loading} borderless />
        {currentUser != null && (
          <>
            <Popconfirm title="Are you sure you want to log out?" onConfirm={logout}>
              <Button type="primary" ghost>
                Logout
              </Button>
            </Popconfirm>
            <AccountInfo showNoBadge />
          </>
        )}
        {currentUser == null && <LoginButton />}
      </Space>
    </Container>
  );
};

const Container = styled(Flex)`
  width: 100%;
  height: 100px;
  background-color: ${RacemapColors.CloudBlue};
  z-index: 10;
  padding: 10px;
  flex-direction: row;

  @media screen and (min-width: 576px) {
    padding: 20px 40px;
  }
`;

const Title = styled.div`
  color: ${RacemapColors.DarkBlue};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1.4em;
  font-weight: bolder;
  line-height: 1em;
  width: 99%;

  padding-bottom: 4px;
  margin-bottom: 0.1em;

  @media screen and (min-width: 576px) {
    width: unset;
    font-size: 2em;
  }
`;
